/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_New_RunInputs */

const cs_pm_new_run = /** @type {(inputs: Pm_New_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový běh`)
};

const en_pm_new_run = /** @type {(inputs: Pm_New_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New run`)
};

/**
* | output |
* | --- |
* | "New run" |
*
* @param {Pm_New_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_new_run = /** @type {((inputs?: Pm_New_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_New_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_new_run(inputs)
	return cs_pm_new_run(inputs)
});